export default {
  orders: {
    data: []
  },
  error: false,
  errorMessage: '',
  params: {
    state_auth:null,
    filter_date: [],
    filter_status: '',
    paginate: true,
    page: 1,
    perPage: 100,
    sortBy: 'total_order_value',
    sort: 'DESC',
    seller_id: null
  },
  sellers: [],
  preloader: false,
  states: [],
  contact:[],
  providers:[],
}



// WEBPACK FOOTER //
// ./src/modules/ordersManagement/state.js